import React, { useState, useEffect,} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { GpsBaseURL, Role } from '../../api/DataApis';
import { Link, Navigate, useLocation, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import "./User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from "../Settings/Loader";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { LuUser } from 'react-icons/lu';
import { useRef } from "react";



  const OrdersProcessingLogs = () => {
  const [corporateData, setCorporateData] = useState([]);
  const [selectedCorporate, setSelectedCorporate] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState("0");
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [popupInput, setPopupInput] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [currentPage, setCurrentPage] = useState(1); 
  const [selectStatusType, setselectedStatusType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [loder, setLoader] =  useState(false);

  const [searchTerms, setSearchTerms] = useState({
    srNo: '',
    name: '',
    email: '',
    phone: '',
    meterTransactions: '',
    rfids: '',
    wallet: '',
    status: '',
    createdDate: '',
    actions: ''
  });


  let navigate = useNavigate();
  const handleSearch = (column, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [column]: value
    }));
  };
  const fileInputRef = useRef(null);
  const handleButtonClick = (event) => {
    event.preventDefault();
    fileInputRef.current.click(); // Trigger hidden input
  };
  const handleFileChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];

    if (file) {
      setSelectedFile(file);
      confirmUpload(file); // Ask for confirmation
    }
  };
  const confirmUpload = (file) => {
    Swal.fire({
      title: "Upload Confirmation",
      html: `
        <p>Do you want to upload <strong>${file.name}</strong>?</p>
        <input id="swal-input-title" class="swal2-input" placeholder="Enter Title" />
        <input id="swal-input-comment" class="swal2-input" placeholder="Enter Comment" />
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, upload it!",
      cancelButtonText: "No, cancel!",
      preConfirm: () => {
        const title = document.getElementById("swal-input-title").value;
        const comment = document.getElementById("swal-input-comment").value;
  
        if (!title || !comment) {
          Swal.showValidationMessage(`Please enter both Title and Comment.`);
          return false;
        }
        return { title, comment };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { title, comment } = result.value;
        uploadFile(file, title, comment);
      } else {
        setSelectedFile(null); // Reset if canceled
      }
    });
  };
  
  const uploadFile = async (file, title, comment) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", title);
    formData.append("comment", comment);
  
    setLoader(true);
  
    try {
      const response = await fetch(`${GpsBaseURL}/order/add-manual-excel-order`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
        body: formData,
      });
  
      if (response.ok) {
        Swal.fire("Success!", "File uploaded successfully.", "success");
      } else {
        Swal.fire("Error!", "File upload failed.", "error");
      }
    } catch (error) {
      Swal.fire("Error!", "Something went wrong.", "error");
    }
  
    setLoader(false);
  };
  
  
  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/manualorder`);
    }
 
    const corporateOptions = corporateData.map(corporate => ({
      value: corporate._id,
      label: `${corporate.corporate_name} (${corporate?.email})`,
      _id: corporate._id,
    }));

    const handleUploadFile = () => {

    }
 
  
 
  
  document.title = "Orders Processing Logs";
  const handlecorporateChange = (selectedOption) => {
    console.log("selectedOption:", selectedOption);
    
    if (selectedOption) {
      setSelectedCorporate(selectedOption._id);
    } else {
      setSelectedCorporate(null); // Reset state when cleared
    }
  };
  console.log("selectedCorporate", selectedCorporate);
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  
    const fetchCorporatesData = async () => {
      setLoading(true);
      const apiEndpoint = `${GpsBaseURL}/corporate`;
      try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("Countries response", response);
        setCorporateData(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      } finally {
        setLoading(false);
      }
    };
 useEffect(() => {
      if (Role === "false") {
        fetchCorporatesData();  // Only fetch corporate data if Role === "false"
      }
    }, [Role]);

    const fetchUsers = async (page) => {
    setLoadings(true);
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/order/order-processing-logs?page=`+page);
 
   
    
    // Prepare query parameters
    const queryParams = [];
    
    // Add search term to the query params if it's not empty
    // if (searchTerm) queryParams.push(`searchText=${searchTerm}`);
    

   
    if (searchQuery) queryParams.push(`searchText=${searchQuery}`);
    // if(OrderprocessingID) queryParams.push(`order_processing_log_id=${OrderprocessingID}`)
    if (selectStatusType) queryParams.push(`status=${selectStatusType}`);
    if(selectedCorporate) queryParams.push(`corporate_id=${selectedCorporate}`);
    
    
    const apiUrl = `${apiEndpoint}`;
  
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
     
      setFilteredData(response?.data?.data);
      setTotalCount(response?.data?.count || 0);
      setLimit(response?.data?.limit);
      setPageCount(Math.ceil(response?.data?.count / response?.data?.limit)); // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchUsers(page);
  }, [searchTerm,  page]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };
   const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle submit to fetch filtered data
const handleSearchSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const page = 1; // Always reset to page 1 when searching
  setPage(page); // Ensure pagination resets to the first page

  // Set loading to true while fetching
  setLoadings(true); 

  // Prepare the base URL and query parameters
  let url = `${GpsBaseURL}/order/order-processing-logs`;
  const params = [];

  // Add search term if present

//   if (selectedStatusType) {
//     params.push(`status=${selectStatusType}`);
// }
// if(selectedCorporate) {
//   params.push(`corporate_id=${selectedCorporate}`);
// }

  // Add selected country, state, and city to the params
 
 

  // Append query parameters to the URL
  if (params.length) {
      url += `&${params.join('&')}`;
  }

  try {
      const res = await axios.get(url, {
          headers: {
              Authorization: `Bearer ${uniqueToken}`, // Include authorization token
          },
      });

      if (res && res?.data && res?.data?.data) {
          setFilteredData(res?.data?.data); // Update filtered data
          setTotalCount(res?.data?.data?.length); // Set total count based on the filtered data length
          setPageCount(Math.ceil(res?.data?.totalCount / Limit)); // Update page count based on results
      } else {
          setFilteredData([]); // If no data is returned, set filtered data to empty
          setTotalCount(0); // If no data is returned, set totalCount to 0
      }
      
  } catch (error) {
      console.error("Error fetching filtered data:", error);
  } finally {
      setLoadings(false); // Set loading to false after fetching
  }
};
console.log("filteredDaaata", filteredData);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3">Orders Processing Logs({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
    </div>
  </div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
 
</div>
 <div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <Loader /> 
  ) : totalCount === 0 ? (
    <div className="text-center">
      <h5>No User Data Found</h5> {/* Message to indicate no data found */}
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Sr No</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Title</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Comment</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Pending Order Count</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Success Order Count</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Total Order Count</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Status</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Created Date</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Created By</th>
 
  </tr>
</thead>

        <tbody>
          {filteredData?.map((user, index) => (
            <tr key={index}>
              <td>{(page - 1) * Limit + index + 1}</td>
 

       <td>{user?.title}</td>
       <td>{user?.comment}</td>
      <td><Link to ={`/manualorder/${user?._id}`}  state={{ OrderProcessingData: user, Orderstatus : "Pending" , OrderProcessingID : user?._id}}>{user?.pendingOrdersCount}</Link></td>
       <td><Link to ={`/manualorder/${user?._id}`} state={{ OrderProcessingData: user, Orderstatus : "Success", OrderProcessingID : user?._id }}>{user?.successOrdersCount}</Link></td>
       <td><Link to ={`/manualorder/${user?._id}`} state={{ OrderProcessingData :user, OrderProcessingID : user?._id}} >{user?.totalCount}</Link></td>
       <td> <button
      style={{
      width: "106px",
      textAlign: "center",  // Ensures horizontal centering
      padding: "5px",
      fontSize: "12px",
      display: "flex",        // Makes the button a flex container
      justifyContent: "center", // Centers content horizontally
      alignItems: "center",     // Centers content vertically
      backgroundColor: 
        user?.status === 'Pending' ? 'yellow' :
        user?.status === 'Cancelled' ? 'Red' :
        user?.status === 'Completed' ? 'green' :
         user?.status ===  'Shipped' ? 'Orange' : "Purple",  // Default color
    }}
    className="btn"
  >
    {user?.status}
  </button></td>
   <td>{user?.createdAt}</td>
   <td>{user?.created_by}</td>
                        
            </tr>
          ))}   
        </tbody>
      </table>
</div>
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>

 </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default OrdersProcessingLogs;
